import Axios from "axios";

export const getCarriersActive = async () => {
  try {
    const {data} = await Axios.get(
      `/api/v1/carriers/active`
    )
    // console.log({ data })
    return data.map(carrier => ({
      ...carrier,
      value: carrier.name,
      label: `[${carrier?.order_shop?.identifier || ""}] ${carrier.name}`,
    }))
  } catch (err) {
    console.log("getCarriersActive: ", err)
    return []
  }
};